import React from 'react';
import { useLocaleState, useTranslate } from 'react-admin';
import { Typography } from '@mui/material';

/**
 * Kaynak dil bilgilendirme satırı — create ve edit formlarında paylaşılır.
 */
export const SourceLanguageBanner = ({ isEdit = false, record }) => {
  const [locale] = useLocaleState();
  const translate = useTranslate();

  const currentLangCode = isEdit ? record?.sourceLanguage || 'tr' : locale;
  const isTr = currentLangCode === 'tr';
  const isEn = currentLangCode === 'en';

  const langName = isTr ? 'Türkçe' : isEn ? 'English' : currentLangCode.toUpperCase();

  const description = isEdit
    ? translate(
        'form.source_language_locked_desc',
        `Bu kaydın kaynak dili kilitlidir (${langName}). Güncellemeler esas alınarak diğer dillere DeepL ile otomatik çevrilecektir.`,
        { lang: langName },
      )
    : translate(
        'form.source_language_desc',
        'Bu dilde yazın; diğer diller DeepL ile çevrilir. Dil değiştirmek için navbar’ı kullanın.',
      );

  return (
    <Typography
      variant="caption"
      component="div"
      noWrap
      title={description}
      sx={{
        display: 'block',
        mb: 1.5,
        maxWidth: '100%',
        color: '#6b7280',
        fontSize: '0.75rem',
        fontWeight: 400,
        lineHeight: 1.4,
      }}
    >
      {translate('form.source_language_title', 'Kaynak Dil:')}{' '}
      <span style={{ color: '#2563EB', fontWeight: 500 }}>
        {langName}
        {isEdit ? ' (Kilitli)' : ''}
      </span>
      {' · '}
      {description}
    </Typography>
  );
};

export default SourceLanguageBanner;
